/* istanbul ignore file */
import dynamic from 'next/dynamic';

import type { ContentstackSection } from 'src/types/Contentstack';
import type { Transformer } from 'src/types/Transformer';
import type { SectionRenderer } from '../../../types/Section';

/* istanbul ignore next */
export const renderer: SectionRenderer<Record<string, never>> = dynamic(() =>
  import('../../../components/sections/UnsupportedSection').then((mod) => mod.UnsupportedSection),
);

export const createPreviewErrorTransformer = (errorMessage: string) => {
  const previewErrorTransformer: Transformer<ContentstackSection, Record<string, never>> = ({
    _metadata,
  }) => ({
    uid: _metadata.uid,
    props: {},
    errors: [{ message: errorMessage }],
  });

  return previewErrorTransformer;
};
